// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.art-design-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.art-design-section .art-design-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.art-design-section .art-design-wrap .heading-text-box .heading-img {
  display: none;
}
.art-design-section .art-design-wrap .heading-text-box .heading-text {
  text-align: center;
  position: static;
}
.art-design-section .art-design-wrap .art-design-box {
  width: 100%;
  max-width: 77.5rem;
  margin: 0 auto;
}
.art-design-section .art-design-wrap .art-design-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
}
.art-design-section .art-design-wrap .art-design-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
.art-design-section .art-design-wrap .art-design-box .img-wrap {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 4rem 0;
}
.art-design-section .art-design-wrap .art-design-box .img-wrap .img-box {
  width: 100%;
  max-width: 15.875rem;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 2.5rem;
}
.art-design-section .art-design-wrap .art-design-box .img-wrap .img-box img {
  width: 100%;
  max-width: 100%;
  height: auto;
}
.art-design-section .art-design-wrap .art-design-box .img-wrap .img-box .title-text {
  color: var(--black-1000);
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
}
@media screen and (max-width: 991.98px) {
  .art-design-section {
    padding: 2.5rem 0;
  }
  .art-design-section .art-design-wrap .art-design-box .para-text {
    font-size: 1rem;
  }
  .art-design-section .art-design-wrap .art-design-box .btn-box {
    margin-top: 2.5rem;
  }
  .art-design-section .art-design-wrap .art-design-box .img-wrap {
    padding: 2.5rem 0;
  }
  .art-design-section .art-design-wrap .art-design-box .img-wrap .img-box {
    max-width: 10rem;
    gap: 1.25rem;
  }
  .art-design-section .art-design-wrap .art-design-box .img-wrap .img-box .title-text {
    font-size: 1.25rem;
  }
}
@media screen and (max-width: 767.98px) {
  .art-design-section {
    padding: 2rem 0;
  }
  .art-design-section .art-design-wrap .art-design-box .para-text {
    font-size: 0.875rem;
  }
  .art-design-section .art-design-wrap .art-design-box .btn-box {
    margin-top: 1.25rem;
  }
  .art-design-section .art-design-wrap .art-design-box .img-wrap {
    padding: 1.25rem 0;
  }
  .art-design-section .art-design-wrap .art-design-box .img-wrap .img-box {
    max-width: 7rem;
    gap: 0.875rem;
  }
  .art-design-section .art-design-wrap .art-design-box .img-wrap .img-box .title-text {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ArtDesignSection/ArtDesignStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,aAAA;AAAR;AAGM;EACE,kBAAA;EACA,gBAAA;AADR;AAKI;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AAHN;AAKM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAHR;AAMM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAJR;AAOM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AALR;AAOQ;EACE,WAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;AALV;AAOU;EACE,WAAA;EACA,eAAA;EACA,YAAA;AALZ;AAQU;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AANZ;AAaE;EAzEF;IA0EI,iBAAA;EAVF;EAcM;IACE,eAAA;EAZR;EAeM;IACE,kBAAA;EAbR;EAgBM;IACE,iBAAA;EAdR;EAgBQ;IACE,gBAAA;IACA,YAAA;EAdV;EAgBU;IACE,kBAAA;EAdZ;AACF;AAqBE;EAtGF;IAuGI,eAAA;EAlBF;EAsBM;IACE,mBAAA;EApBR;EAuBM;IACE,mBAAA;EArBR;EAwBM;IACE,kBAAA;EAtBR;EAwBQ;IACE,eAAA;IACA,aAAA;EAtBV;EAwBU;IACE,eAAA;EAtBZ;AACF","sourcesContent":[".art-design-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .art-design-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .heading-text-box {\n      .heading-img {\n        display: none;\n      }\n\n      .heading-text {\n        text-align: center;\n        position: static;\n      }\n    }\n\n    .art-design-box {\n      width: 100%;\n      max-width: 77.5rem;\n      margin: 0 auto;\n\n      .para-text {\n        color: var(--black-1000);\n        font-size: 1.5rem;\n        font-weight: 400;\n        line-height: 1.4;\n        text-align: center;\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n\n      .img-wrap {\n        display: flex;\n        justify-content: space-between;\n        gap: 1rem;\n        padding: 4rem 0;\n\n        .img-box {\n          width: 100%;\n          max-width: 15.875rem;\n          height: 100%;\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          flex-direction: column;\n          gap: 2.5rem;\n\n          img {\n            width: 100%;\n            max-width: 100%;\n            height: auto;\n          }\n\n          .title-text {\n            color: var(--black-1000);\n            font-size: 2rem;\n            font-weight: 700;\n            line-height: 1.4;\n            text-align: center;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n    \n    .art-design-wrap {  \n      .art-design-box {\n        .para-text {\n          font-size: 1rem;\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n  \n        .img-wrap {\n          padding: 2.5rem 0;\n  \n          .img-box {\n            max-width: 10rem;\n            gap: 1.25rem;\n  \n            .title-text {\n              font-size: 1.25rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n    \n    .art-design-wrap {  \n      .art-design-box {\n        .para-text {\n          font-size: 0.875rem;\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n  \n        .img-wrap {\n          padding: 1.25rem 0;\n  \n          .img-box {\n            max-width: 7rem;\n            gap: 0.875rem;\n  \n            .title-text {\n              font-size: 1rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
